import React, { useEffect, useState } from 'react';
import { StatCard } from '../../components/ui/StatCard';
import { Card } from '../../components/ui/Card';
import { Table, Tr, Td } from '../../components/ui/Table';
import { Badge } from '../../components/ui/Badge';
import { getBookings } from '../../api/bookings';
import { getAuditLogs } from '../../api/audit';
import { getUsers } from '../../api/auth';
import { Booking, AuditLog, User } from '../../types';
import { formatCurrency, formatDateTime } from '../../utils/format';

export const SuperadminDashboard: React.FC = () => {
  const [bookings, setBookings] = useState<Booking[]>([]);
  const [users, setUsers] = useState<User[]>([]);
  const [logs, setLogs] = useState<AuditLog[]>([]);

  useEffect(() => {
    getBookings().then(r => setBookings(r.data.results || r.data));
    getUsers().then(r => setUsers(r.data.results || r.data));
    getAuditLogs().then(r => setLogs(r.data.results || r.data));
  }, []);

  const confirmed = bookings.filter(b => b.status === 'confirmed').length;
  const pending = bookings.filter(b => b.status === 'pending').length;
  const totalRevenue = bookings.filter(b => b.status === 'confirmed')
    .reduce((s, b) => s + parseFloat(b.total_price), 0);

  return (
    <div>
      <h1 style={{ fontSize: 20, fontWeight: 500, marginBottom: 20 }}>Dashboard — System Owner</h1>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10, marginBottom: 20 }}>
        <StatCard label="Total booking" value={bookings.length} sub={`${confirmed} confirmed`} />
        <StatCard label="Pending payment" value={pending} sub="Perlu konfirmasi" />
        <StatCard label="Total users" value={users.length} sub="Semua role" />
        <StatCard label="Revenue sistem" value={formatCurrency(totalRevenue)} sub="Booking confirmed" />
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
        <Card title="Semua booking">
          <Table headers={['Kode', 'Hotel', 'Agen', 'Harga', 'Status']}>
            {bookings.slice(0, 8).map(b => (
              <Tr key={b.id}>
                <Td><span style={{ fontFamily: 'monospace', fontSize: 12 }}>{b.booking_code}</span></Td>
                <Td>{b.hotel_name}</Td>
                <Td style={{ fontSize: 12 }}>{b.agent_name}</Td>
                <Td style={{ fontWeight: 500 }}>{formatCurrency(b.total_price)}</Td>
                <Td><Badge status={b.status} /></Td>
              </Tr>
            ))}
          </Table>
        </Card>
        <Card title="Audit log terbaru">
          <Table headers={['Waktu', 'Aksi', 'Oleh']}>
            {logs.slice(0, 8).map(l => (
              <Tr key={l.id}>
                <Td style={{ fontSize: 11, color: '#888780' }}>{formatDateTime(l.created_at).split(',')[0]}</Td>
                <Td style={{ fontSize: 12, fontFamily: 'monospace' }}>{l.action}</Td>
                <Td style={{ fontSize: 12 }}>{l.user_name}</Td>
              </Tr>
            ))}
          </Table>
        </Card>
      </div>
      <Card title="Users & Hierarchy">
        <Table headers={['Nama', 'Email', 'Role', 'Parent', 'Status']}>
          {users.map(u => (
            <Tr key={u.id}>
              <Td style={{ fontWeight: 500 }}>{u.name}</Td>
              <Td style={{ fontSize: 12, color: '#888780' }}>{u.email}</Td>
              <Td><Badge status={u.role} label={u.role.replace('_', ' ')} /></Td>
              <Td style={{ fontSize: 12 }}>{u.parent_name || '—'}</Td>
              <Td><Badge status={u.is_active ? 'confirmed' : 'cancelled'} label={u.is_active ? 'aktif' : 'nonaktif'} /></Td>
            </Tr>
          ))}
        </Table>
      </Card>
    </div>
  );
};
